import {createContext} from "react";
import {UserSession} from "../entities/UserSession";

const UserSessionContext = createContext<UserSession | null>(null)

export default UserSessionContext